export default "__VITE_ASSET__D6HB_bE8__"